import { ColumnSettings } from '@mode/legacy/data-access-model-js';
import { VizTypes } from '@mode/shared/contract-common';

export { VizTypes };

// Viz types that can be full height
export enum FullVizTypes {
  Table = VizTypes.Table,
  Text = VizTypes.Text,
}

export type SchemaTabs = 'tables' | 'definitions';

/**
 * @todo change format property to a comprehensive type
 */
export interface PivotTableViewOptions {
  filters?: Array<string>;
  filterValues?: {};
  columnFormats?: ColumnSettings;
  columns?: Array<string>;
  rows?: Array<string>;
  values?: Array<string>;
  aggregator?: string;
  format: any;
}

export type AngularEventCallback<T extends Event> = (ev: { $event: T }) => void;
